export enum EThemes {
  Light = 'light',
  Dark = 'dark',
}

export enum EProviderBySource {
  null,
  native,
  google,
  apple,
}

export enum EEditType {
  Add = 'add',
  Remove = 'remove',
  Edit = 'edit',
}

export enum EUpperCountries {
  US = 'United States',
  CN = 'China',
  AU = 'Australia',
  CA = 'Canada',
  DE = 'Germany',
  ES = 'Spain',
  FR = 'France',
  IT = 'Italy',
  UK = 'United Kingdom',
  PL = 'Poland',
  RU = 'Russia',
  BE = 'Belgium',
  NL = 'Netherlands',
}
